import { ApiService } from '../api.service';
import { CommonService } from '../common.service';
import { ActivatedRoute, Router } from '@angular/router';
var ReportComponent = (function () {
    function ReportComponent(apiService, router, route, commonService) {
        this.apiService = apiService;
        this.router = router;
        this.route = route;
        this.commonService = commonService;
        this.isOpenClass = 0;
        this.assetsRoute = "../../assets";
        this.isShowBackBtn = true;
        this.isHarmonyOS = false;
    }
    ReportComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isHarmonyOS = this.commonService.isHarmonyOS();
        this.isShowBackBtn = localStorage.getItem("source_env") == "LMS_SCORM" ? false : true;
        this.isOpenClass = Number(localStorage.getItem("openClass")) ? 1 : 0;
        this.apiService.ajax({
            'type': 'GET',
            'url': 'sr/exposeoutapi/getAbilityBack'
        }).subscribe(function (result) {
            _this.abilityBack = result.data.abilityBack;
        });
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.assetsRouteUrl = this.assetsRoute + '/picture/feature/sorry.svg';
        this.getReport();
        this.getApiData();
        // $(document).ready(function(){
        //   var o = document.getElementById("div1");
        //   o.addEventListener("webkitAnimationEnd", function () {
        //     this.parentNode.className = "none";
        //   });
        // });
        /*this.report = this.getMockData().details;
        this.currentAbility = this.report[4];
        this.setsmallBallArray(this.currentAbility.ability_id);*/
        this.step = 1;
        this.apiService.ajax({
            'type': 'get',
            'url': '/sr/learningtour',
        }).subscribe(function (result) {
            _this.learningTour = result.pre_survey_meta_ids.length > 0;
        });
    };
    ReportComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.commonService.initPage({
            'backgroundColor': '#3f4c84'
        });
        var that = this;
        setTimeout(function () {
            var num = $('#animationBallWrap').length;
            if (num != 0) {
                _this.hammertime = new Hammer(document.getElementById('animationBallWrap'));
                _this.hammertime.get('swipe').set({ direction: Hammer.DIRECTION_ALL });
                _this.hammertime.on('swipeup swipedown', function (ev) {
                    that.logEventType(ev, that);
                });
            }
        }, 1000);
        if (!that.firstFlag) {
            setTimeout(function () {
                $('#normalBallWrap').show();
            }, 1000);
        }
    };
    ReportComponent.prototype.logEventType = function (ev, that) {
        if (ev.type == "swipeup") {
            $('#firstReportView').css({
                'top': '-100%',
                'opacity': '0'
            });
            that.hammertime.get('swipe').set({ enable: false });
            var len = ($('.radio').length);
            for (var i = 0; i < len; i += 1) {
                $('#rad' + i).removeClass('mymove' + i).addClass('afterMove' + i).text(this.report[i].norm_point);
            }
            if (this.firstFlag) {
                var cid = 0, type = 14;
                this.apiService.ajax({
                    'type': 'GET',
                    'url': '/sr/incentiveLine/firstHintsGetTreasure/' + cid + '/' + type + '/1',
                    'data': {}
                }).subscribe(function (result) { });
            }
            setTimeout(function () {
                $('#firstReportView').hide();
                // $('.coverWrap').hide();
            }, 500);
            setTimeout(function () {
                $('.animationAfterTxt').fadeIn(200);
                $('#normalBallWrap2').show();
                $('#animationBallWrap').hide();
                // $('.animationAfterAudio').addClass('animationAfterFadeIn');
            }, 1600);
        }
    };
    ReportComponent.prototype.smallBallClick = function (i) {
        var that = this;
        $('#bigBall').fadeOut(200);
        setTimeout(function () {
            that.currentAbility = that.smallBallArray[i];
            that.setsmallBallArray(that.currentAbility.ability_id);
            // $('#topBar').css({'width':0});
            $(".description").scrollTop(0);
            $('#bigBall').fadeIn(200);
        }, 200);
        setTimeout(function () {
            $('#topBar' + i).css({ 'left': this.report[i].norm_point * 0.92 + '%' });
            $('#arrowBom' + i).css({ 'left': this.report[i].norm_point * 0.92 + 1.5 + '%' });
        }, 400);
        $('#lowContent').scrollTop(0);
        $('#highContent').scrollTop(0);
    };
    ReportComponent.prototype.setsmallBallArray = function (abilityId) {
        this.smallBallArray = [];
        var that = this;
        this.report.forEach(function (item, index) {
            if (item.ability_id != abilityId) {
                that.smallBallArray.push(item);
            }
        });
        this.smallBallArray = this.shuffle(this.smallBallArray);
        // $('#topBar').css({'width':that.currentAbility.norm_point/100});
    };
    ReportComponent.prototype.getApiData = function () {
        var _this = this;
        var cid = 0, type = 14;
        this.apiService.ajax({
            'type': 'GET',
            'url': '/sr/incentiveLine/firstHintsGetTreasure/' + cid + '/' + type + '/0',
            'data': {}
        }).subscribe(function (result) {
            _this.firstFlag = result.firstFlag;
            // this.firstFlag = true;
        });
        this.apiService.ajax({
            'type': 'GET',
            'url': '/sr/coursedna/queryCourseDNAList',
            'data': {}
        }).subscribe(function (result) {
            for (var i = 0, len = result.length; i < len; i += 1) {
                result[i].totalTime = _this.getTimeformat(result[i].totalTime);
            }
            _this.audio = result;
        });
    };
    ReportComponent.prototype.getReport = function () {
        var _this = this;
        this.apiService.getDNAReport("" + this.surveyId + "").subscribe(function (report) {
            _this.report = report.details;
        });
    };
    ReportComponent.prototype.creatChart = function (index, flag) {
        var charts;
        if (flag) {
            charts = echarts.init(document.getElementById('detailReportChart' + index));
        }
        else {
            charts = echarts.init(document.getElementById('firstReportChart' + index));
        }
        var colorObj = {
            "0": ['rgb(152,162,233)', 'rgb(234,234,234)'],
            "1": ['rgb(146,127,215)', 'rgb(234,234,234)'],
            "2": ['rgb(206,143,203)', 'rgb(234,234,234)'],
            "3": ['rgb(105,122,230)', 'rgb(234,234,234)'],
            "4": ['rgb(99,151,203)', 'rgb(234,234,234)'],
        };
        this.chartData = [
            { value: this.report[index].norm_point, name: '得分' },
            { value: 100 - this.report[index].norm_point, name: '总分' },
        ];
        this.chartsOpt = {
            tooltip: {
                show: false,
            },
            legend: {
                show: false,
            },
            toolbox: {
                show: false,
            },
            calculable: true,
            color: colorObj[index],
            series: [
                {
                    name: 'DNA检测',
                    type: 'pie',
                    radius: ['91%', '100%'],
                    hoverAnimation: false,
                    // startAngle: 275,
                    // radius : ['25rem', '30rem'],
                    itemStyle: {
                        normal: {
                            label: {
                                show: false
                            },
                            labelLine: {
                                show: false
                            }
                        }
                    },
                    data: this.chartData
                }
            ],
        };
        charts.setOption(this.chartsOpt);
    };
    ReportComponent.prototype.linkToAudio = function (i) {
        var _this = this;
        this.route.params.subscribe(function (params) {
            var learningPathOrLearningTourId = params['learningPathOrLearningTourId'];
            var surveyMetaId = params['surveyMetaId'];
            var method = params['method'];
            var link = ['audioPlay', learningPathOrLearningTourId, surveyMetaId, _this.surveyId, method, i];
            _this.router.navigate(link);
        });
    };
    ReportComponent.prototype.showReport = function (i) {
        var _this = this;
        $('#detailReport' + i).show().addClass('scaleAll' + i).addClass('index300');
        setTimeout(function () {
            $('#container' + i).addClass('scaleOut');
            // $('#topBar'+i).css({'width':0});
            setTimeout(function () {
                // this.creatChart(i,true);
                $('#topBar' + i).css({ 'left': _this.report[i].norm_point * 0.92 + '%' });
                $('#arrowBom' + i).css({ 'left': _this.report[i].norm_point * 0.92 + 1.5 + '%' });
                $('#exitBtn' + i).show();
            }, 250);
        }, 650);
    };
    ReportComponent.prototype.firstShowReport = function (i) {
        var _this = this;
        console.log(this.report[i].norm_point);
        $('#normalBallWrap3').find('#detailReport' + i).show().addClass('firstScale').addClass('index300');
        setTimeout(function () {
            $('#normalBallWrap3').find('#container' + i).addClass('scaleOut');
            // $('#normalBallWrap3').find('#topBar'+i).css({'width':0});
            setTimeout(function () {
                // this.creatChart(i,false);
                // $('#normalBallWrap3').find('#topBar'+i).animate({'width':this.report[i].norm_point+'%'});
                $('#normalBallWrap3').find('#topBar' + i).css({ 'left': _this.report[i].norm_point * 0.92 + '%' });
                $('#normalBallWrap3').find('#arrowBom' + i).css({ 'left': _this.report[i].norm_point * 0.92 + 1.5 + '%' });
                $('#normalBallWrap3').find('#exitBtn' + i).show();
            }, 250);
        }, 200);
    };
    ReportComponent.prototype.getTimeformat = function (timeSeconds) {
        var theTime = timeSeconds; // 秒
        var theTime1 = 0; // 分
        var theTime2 = 0; // 小时
        if (theTime > 60) {
            theTime1 = Math.floor(theTime / 60);
            theTime = Math.floor(theTime % 60);
            if (theTime1 > 60) {
                theTime2 = Math.floor(theTime1 / 60);
                theTime1 = Math.floor(theTime1 % 60);
            }
        }
        var result = "" + Math.floor(theTime);
        if (theTime < 10) {
            result = "0" + result;
        }
        if (theTime1 > 0) {
            result = "" + Math.floor(theTime1) + "'" + result;
        }
        else {
            result = "0:" + result;
        }
        if (theTime2 > 0) {
            result = "" + Math.floor(theTime2) + "'" + result;
        }
        return result;
    };
    ReportComponent.prototype.onRadioClick = function (index) {
        var that = this;
        this.currentAbility = this.report[index];
        this.setsmallBallArray(this.currentAbility.ability_id);
        this.step = 2;
        if (this.learningTour) {
            $('#backButton').css({ 'top': '12.1rem' });
        }
        setTimeout(function () {
            $('#topBar').animate({ 'width': that.currentAbility.norm_point + '%' });
        }, 200);
    };
    ReportComponent.prototype.shuffle = function (array) {
        var tmp, current, top = array.length;
        if (top)
            while (--top) {
                current = Math.floor(Math.random() * (top + 1));
                tmp = array[current];
                array[current] = array[top];
                array[top] = tmp;
            }
        return array;
    };
    ReportComponent.prototype.openTip = function () {
        $("#shade").fadeIn(500);
        $("#closeBtn").fadeIn(500);
        $("#exception_clause").fadeIn(500);
        //document.getElementById("list_wrap").ontouchmove=function(e){e.preventDefault();}
        document.getElementById("shade").ontouchmove = function (e) { e.preventDefault(); };
        document.getElementById("closeBtn").ontouchmove = function (e) { e.preventDefault(); };
        document.getElementById("exception_clause").ontouchmove = function (e) { e.preventDefault(); };
    };
    ReportComponent.prototype.closeTip = function () {
        $("#closeBtn").fadeOut(500);
        $("#shade").fadeOut(500);
        $("#exception_clause").fadeOut(500);
    };
    ReportComponent.prototype.close = function () {
        var preUrl = this.commonService.getStorage('dnaReturnUrl');
        if (preUrl) {
            window.location.href = preUrl;
        }
        else {
            var projectId = localStorage.getItem("projectId");
            var link = ['learning-map'];
            if (projectId) {
                link = ['learning-project', projectId];
            }
            this.router.navigate(link);
        }
        this.commonService.removeStorage('dnaReturnUrl');
    };
    ReportComponent.prototype.closeLayer = function (i) {
        $('#container' + i).removeClass('scaleOut');
        $('#detailReport' + i).removeClass('scaleAll' + i).removeClass('index300').hide();
        $('#exitBtn' + i).hide();
    };
    ReportComponent.prototype.firstCloseLayer = function (i) {
        $('#normalBallWrap3').find('#container' + i).removeClass('scaleOut');
        $('#normalBallWrap3').find('#detailReport' + i).removeClass('firstScale').removeClass('index300').hide();
        $('#normalBallWrap3').find('#exitBtn' + i).hide();
    };
    return ReportComponent;
}());
export { ReportComponent };



// WEBPACK FOOTER //
// ./src/app/report/report.component.ts.pre-build-optimizer.js